'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setQueue;
// Queue for MOVEAnalytics in case it is not yet loaded.

function setQueue() {
  if (typeof window !== 'undefined') {
    window.MOVEAnalytics = window.MOVEAnalytics || { q: [], init: function init() {
        this.q.push({ t: 'init', a: arguments });
      }, trackPage: function trackPage() {
        this.q.push({ t: 'trackPage', a: arguments });
      }, trackEvent: function trackEvent() {
        this.q.push({ t: 'trackEvent', a: arguments });
      } };
  }
}


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/@moveinc/rdc-tracking/distribution/queue.js
// module id = 934
// module chunks = 48 49 51